import React, { useState } from 'react';
import './Login.css';
import { useAdminAuth } from '../../context/AdminAuthContext';
import { toast, Toaster } from 'react-hot-toast';
import { FaEye, FaEyeSlash, FaLock, FaUser } from 'react-icons/fa';

const Login = () => {
  const { login, loading } = useAdminAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    
    if (!username.trim()) {
      newErrors.username = 'Username is required';
    }
    
    if (!password) {
      newErrors.password = 'Password is required';
    } else if (password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      toast.error('Please fix the errors in the form');
      return;
    }
    
    try {
      const result = await login(username, password);
      if (result && result.success) {
        toast.success('Login successful!');
      }
    } catch (error) {
      toast.error(error.message || 'Login failed. Please try again.');
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="login-container">
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 8000,
          style: {
            background: '#333',
            color: '#fff',
            borderRadius: '8px',
          },
          success: {
            iconTheme: {
              primary: '#4caf50',
              secondary: '#fff',
            },
          },
          error: { 
            iconTheme: {
              primary: '#f44336',
              secondary: '#fff',
            },
          },
        }}
      />
      
      <div className="login-box animate-fade-in">
        <div className="login-header">
          <h1 className="login-title animate-slide-down">Welcome Back</h1>
          <p className="login-subtitle animate-slide-down-delay">Sign in to your admin account</p>
        </div>
        
        <form onSubmit={handleLogin} className="animate-fade-in-delay">
          <div className="input-group">
            {/* <div className="input-icon">
              <FaUser />
            </div> */}
            <input
              type="text"
              placeholder="Username"
              className={`input-field ${errors.username ? 'input-error' : ''}`}
              value={username}
              onChange={(e) => {
                setUsername(e.target.value);
                if (errors.username) {
                  setErrors({...errors, username: null});
                }
              }}
            />
            {errors.username && <div className="error-message">{errors.username}</div>}
          </div>
          
          <div className="input-group">
            {/* <div className="input-icon">
              <FaLock />
            </div> */}
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Password"
              className={`input-field ${errors.password ? 'input-error' : ''}`}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                if (errors.password) {
                  setErrors({...errors, password: null});
                }
              }}
            />
            <button
              type="button"
              className="toggle-password"
              onClick={togglePasswordVisibility}
              aria-label="Toggle password visibility"
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
            {errors.password && <div className="error-message">{errors.password}</div>}
          </div>

          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? (
              <div className="button-loader">
                <div className="spinner"></div>
                <span>Signing In...</span>
              </div>
            ) : (
              "Sign In"
            )}
          </button>
        </form>
        
        <div className="login-footer animate-fade-in-delay-long">
          <div className="login-decoration">
            <div className="decoration-dot"></div>
            <div className="decoration-line"></div>
            <div className="decoration-dot"></div>
          </div>
          <p className="copyright">© {new Date().getFullYear()} Admin Panel</p>
        </div>
      </div>
      
      <div className="background-decoration">
        <div className="bg-circle circle-1"></div>
        <div className="bg-circle circle-2"></div>
        <div className="bg-circle circle-3"></div>
      </div>
    </div>
  );
};

export default Login;
